import { useQuery } from "@tanstack/react-query"
import api from "../../../services/api"


export function useWholesaleCustomerSales() {
  return useQuery({
    queryKey: ["wholesale-customer_sales"],
    staleTime: 1000 * 60 * 5, 
    queryFn: async () => {
      const res = await api.get("/api/wholesale/customer_insights/customer_sales")
      const raw = res.data.customer_sales

      return raw.map((item: any) => ({
        customer_name: item.customer_name,
        customer_type: item.customer_type,
        total_sold: item.total_sold,
        last_invoice_date: item.last_invoice_date,
      }))
    }
  })
}
